<form [formGroup]="rootForm" *ngIf="! currentControl.disabled">
  <div class="form-group form-row mx-1">
    <label [for]="idHtml">{{libelle$ | async }}</label>
    <textarea [readOnly]="afficherEnLectureSeule" [placeholder]="placeholder" [maxlength]="longueurMax" [class.is-warning]="aErreurCroiseeActive()" [class.is-invalid]="champInvalide()"
      [class.is-valid]="champValide()" [formControlName]="label" class="form-control" [rows]="longueurRow" [id]="idHtml"></textarea>
    <small *ngIf="enLectureSeule===false" class="col-12 form-text text-muted text-right">{{ rootForm.get(label).value?.length }} / {{ longueurMax }}</small>
    <bis-affiche-erreurs *ngIf="erreursAffichable()" class="col-12" [erreurs]="rootForm.get(label).errors"></bis-affiche-erreurs>
  </div>
</form>